"use client";
import { useEffect } from "react";
import { logError } from "@jetblue/dotcom-fe-logger";
import {
  registerConsentChangeListener,
  resolveConsentDecision,
  setTrustedConsentOrigin,
} from "./consent";
import { registerConsentSynchronization } from "./synchronization";

export const TrustArcClient = ({
  trustArcOrigin,
}: {
  trustArcOrigin: string;
}) => {
  useEffect(() => {
    setTrustedConsentOrigin(trustArcOrigin);
    registerConsentSynchronization();
    registerConsentChangeListener();

    // eslint-disable-next-line unicorn/prefer-await -- the catch makes the most sense here
    resolveConsentDecision().catch((error: unknown) => {
      void logError({
        error,
        message: "Failed to resolve TrustArc consent decision",
      });
    });
  }, [trustArcOrigin]);

  return null;
};
